module.exports = __webpack_public_path__ + "media/costreaming/banner-642fdddf.png";